import alasql from "alasql";
import React, { useEffect, useState } from "react";
import { useAPIs } from "../../apis/APIsConfig";
import { maxNumber } from "../../services/utils";
import getEstadoDesc from "../../utils/estados";
import { useGlobalStore } from "../../utils/global";
import { useForm } from "../../utils/hooks";
import { formatDate } from "../../utils/moment";
import AsideModal from "../common/AsideModal";
import Pagination from "../common/Pagination";

const pageSize = 5;

export function CommonTable({ ...props }) {
  useAPIs();

  const { loading, showLoading, hideLoading } = useGlobalStore();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [detail, setDetail] = useState<any>({});
  const [data, setData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentState, setCurrentState] = useState<string>("all");
  const [filtered, setFiltered] = useState<any[]>([]);
  const [formState, setError, changeHandler, reset] = useForm({
    search: "",
  });

  useEffect(() => {
    props.getData().then((resData) => {
      showLoading();
      setCurrentPage(1);

      resData.sort((a, b) =>
        a.fecha < b.fecha ? 1 : b.fecha < a.fecha ? -1 : 0
      );

      setData(resData);
      setFiltered([...resData]);
      hideLoading();
    });
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    applyFilters();
  }, [formState.data.search]);

  useEffect(() => {
    setCurrentPage(1);
    applyFilters();
  }, [currentState]);

  function getVisibleData() {
    // Pagination
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filtered.slice(firstPageIndex, lastPageIndex);
  }

  function applyFilters() {
    // Estado
    var allData = [...data];
    if (currentState !== "all") {
      allData = [...data.filter((item) => item.estado === currentState)];
    }

    // Global search
    if (formState.data.search) {
      allData = [
        ...allData.filter((item) =>
          item.codSolicitud.toString().includes(formState.data.search)
        ),
      ];
    }

    setFiltered(allData);
  }

  function getEstados(): { cant: number; estado: string }[] {
    return alasql("SELECT count(*) as cant, estado FROM ? GROUP BY estado", [
      data,
    ]) as { cant: number; estado: string }[];
  }

  function showDetails(codSolicitud) {
    props.getDetailById(codSolicitud).then((res) => {
      setDetail(res.data.value);
      setIsOpen(true);
    });
  }

  return (
    <div className="w-full pt-[72px]">
      <div className="content-tab">
        {getVisibleData().length > 0 && (
          <nav className="flex space-x-8 md:space-x-10 xl:space-x-16 overflow-auto xl:w-full lg:w-[580px] md:w-[450px] w-full">
            <button
              className={`item-nav${currentState === "all" ? " active" : ""}`}
              onClick={() => setCurrentState("all")}
            >
              Todas <span>{filtered.length}</span>
            </button>
            {getEstados().map((item, index) => {
              return (
                <button
                  className={`item-nav${
                    currentState === item.estado ? " active" : ""
                  }`}
                  key={index}
                  onClick={() => setCurrentState(item.estado)}
                >
                  {getEstadoDesc(item.estado)} <span>{item.cant}</span>
                </button>
              );
            })}
          </nav>
        )}
        <div className="block lg:flex items-center justify-between py-6">
          <form
            className="min-w-full lg:min-w-[400px] xl:min-w-[488px]"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            {data.length > 0 && (
              <div className="form-group">
                <div className="form-icon">
                  <i className="icon icon-search left text-[12px] text-gray-80"></i>
                  <input
                    type="number"
                    className="form-control large"
                    placeholder="Buscar por Número de Solicitud"
                    value={formState.data.search}
                    onChange={changeHandler("search")}
                    pattern="[0-9]*"
                    onKeyPress={maxNumber(5)}
                  />
                </div>
              </div>
            )}
          </form>

          {props.onCreate && (
            <button
              onClick={props.onCreate}
              className="btn btn-primary btn-medium w-full lg:w-auto mt-6 lg:mt-0"
            >
              {props.createText}
            </button>
          )}
        </div>
        <div className="block">
          <div id="all" className="tabs active">
            {/* EMPTY TABLE */}
            {!data.length && !loading && (
              <div className="content-message-empty">
                <div className="icon-contain">
                  <i className="icon icon-reclamation"></i>
                </div>
                <div className="description">
                  <h2>{props.emptyTableTitle}</h2>
                  <p>{props.emptyTableDesc}</p>
                </div>
              </div>
            )}
            <ul className="block space-y-4">
              {getVisibleData().map((item, index) => {
                return (
                  <li key={index}>
                    <div className="request-card">
                      <div className="items-description">
                        <div className="title">
                          <div className="icon-container">
                            <i className={`icon icon-${props.icon}`}></i>
                          </div>
                          <div>
                            <h5>Solicitud No. {item.codSolicitud}</h5>
                            {props.getDetailById && (
                              <button
                                onClick={() => showDetails(item.codSolicitud)}
                                className="btn-icon btn-secondary btn-small inline-flex xlg:hidden"
                              >
                                <i className="icon icon-arrow-right-short text-[12px]"></i>
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="description">
                          <small>Comentario:</small>
                          <p>{item.comentario}</p>
                        </div>
                        <div className="description">
                          <small>Fecha:</small>
                          <p>{formatDate(item.fecha, "DD MMMM YYYY")}</p>
                        </div>
                        <div className="description">
                          <small>Estado: </small>
                          <span
                            className={`tag ${
                              getEstadoDesc(item.estado) === "Resuelto"
                                ? "info"
                                : "warning"
                            }`}
                          >
                            {getEstadoDesc(item.estado)}
                          </span>
                        </div>
                      </div>
                      {props.getDetailById && (
                        <button
                          onClick={() => showDetails(item.codSolicitud)}
                          className="btn btn-small btn-secondary hidden xlg:inline-flex"
                        >
                          Ver Detalles{" "}
                          <i className="icon icon-arrow-right-short left"></i>
                        </button>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
            <div className="flex justify-center pt-8">
              <Pagination
                currentPage={currentPage}
                totalCount={filtered.length}
                pageSize={pageSize}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        </div>
      </div>

      <AsideModal
        show={isOpen}
        onClose={() => setIsOpen(false)}
        AsideContent={
          <>
            <div className="icon-container">
              <i className={`icon icon-${props.icon}`}></i>
            </div>
            <nav className="nav-modal">
              <div className="description">
                <i className="icon icon-file"></i>
                <div className="block pl-5">
                  <p>Tipo</p>
                  <b>Solicitud</b>
                </div>
              </div>
              <div className="description">
                <i className="icon icon-analytics"></i>
                <div className="block pl-5">
                  <p>Número</p>
                  <b>{detail.codSolicitud}</b>
                </div>
              </div>
              <div className="description">
                <i className="icon icon-calendar"></i>
                <div className="block pl-5">
                  <p>Fecha</p>
                  <b>{formatDate(detail.fecha, "DD MMMM YYYY")}</b>
                </div>
              </div>
              {/*<a href="tel:8096648346" className="description">
                <i className="icon icon-phone"></i>
                <div className="block pl-5">
                  <p>Telefono</p>
                  <b>809-664-8346</b>
                </div>
        </a>*/}
            </nav>
          </>
        }
      >
        <ul className="list-description">
          <li>
            <div className="items-description">
              <span className="tag warning">
                {getEstadoDesc(detail.estado)}
              </span>
              <h5 className="lead text-gray-80 pt-4 font-semibold">
                Solicitud No. {detail.codSolicitud}
              </h5>
            </div>
          </li>
          {detail.comentario && (
            <li>
              <div className="items-description">
                <p className="text-gray-70 text-body-1 font-body font-normal mb-2">
                  Comentario:
                </p>
                <b className="text-gray-80 text-body-1 font-body font-semibold">
                  {detail.comentario}
                </b>
              </div>
            </li>
          )}
          {/*detail.MotivoDesc && (
            <li>
              <div className="items-description">
                <p className="text-gray-70 text-body-1 font-body font-normal mb-2">
                  Motivo:
                </p>
                <b className="text-gray-80 text-body-1 font-body font-semibold">
                  {detail.MotivoDesc}
                </b>
              </div>
            </li>
          )*/}
          {/*detail.Comentario && (
            <li>
              <div className="items-description">
                <p className="text-gray-70 text-body-1 font-body font-normal mb-2">
                  Descripción:
                </p>
                <b className="text-gray-80 text-body-1 font-body font-semibold">
                  {detail.comentario}
                </b>
              </div>
            </li>
          )*/}
          {/*<li>
            <div className="items-description border-none">
              <p className="text-gray-70 text-body-1 font-body font-normal mb-2">
                Documentos adjuntos
              </p>
              <a href="#!" className="btn-download">
                <div className="flex items-center pr-2">
                  <div className="icon-container">
                    <i className="icon icon-saved"></i>
                  </div>
                  <h5 className="text-body-1 text-gray-80 font-body font-semibold pl-4">
                    J.alvarez Formulario
                  </h5>
                </div>
                <i className="icon icon-download text-[26px] text-gray-50"></i>
              </a>
            </div>
          </li>*/}
        </ul>
      </AsideModal>
    </div>
  );
}
